export type manageSaveSearchFilterSliceState = {
  folderName: string;
  pageNumber: number;
  activeTab : string;
  activeTabFolderCount: number
}

export const manageSaveSearchFilterSliceInitialState: manageSaveSearchFilterSliceState = (() => {
    
    return {
        folderName: "",
        pageNumber: 0,
        activeTab: "Saved Searches",
        activeTabFolderCount : 0
    }
})()